import type { FC } from "react";

import classNames from "classnames";

import styles from "./ProgressBarChunk.module.scss";

type ProgressBarChunkProps = {
  isLast?: boolean;
  isFirst?: boolean;
  isFilled?: boolean;
  className?: string;
};

export const ProgressBarChunk: FC<ProgressBarChunkProps> = ({ isFilled, isFirst, isLast, className }) => {
  return (
    <div
      data-testid="progressBarChunk"
      className={classNames(styles.progressBarChunk, "light-theme", className, {
        [styles.progressBarChunkFilled]: isFilled,
        [styles.progressBarChunkFirst]: isFirst,
        [styles.progressBarChunkLast]: isLast,
      })}
    />
  );
};
